module.exports = __webpack_public_path__ + "media/images/flags/64/United-Nations-4aae5bcedc09ede9ccab23da637525b7.png";